import { render } from "./BlockAdresa.vue?vue&type=template&id=9a658db2"
import script from "./BlockAdresa.vue?vue&type=script&lang=js"
export * from "./BlockAdresa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__